const resourceClasses = {
  PACKAGE: 'org.olf.kb.Pkg',
  PCI: 'org.olf.kb.PackageContentItem',
  TITLEINSTANCE: 'org.olf.kb.TitleInstance',
};

export default resourceClasses;
